import { Component, Input } from '@angular/core';
import { NavigationService } from '@shared-services/navigation.service';

@Component({
	selector: 'modal-component',
	templateUrl: 'modal.component.html',
	styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
	@Input() public showBackButton: boolean = true;
	@Input() public fullWidth: boolean = false;

	constructor(private readonly navigationService: NavigationService) {}

	public goBack(): void {
		this.navigationService.navigateBack();
	}
}
